import { Link } from "react-router-dom";
import { ArrowRight, CalendarCheck, Ticket } from "lucide-react";

const OFFERS = [
  { Icon: Ticket, title: "5er- & 10er-Karten", text: "Flexibel Termine buchen", id: "cards" },
  { Icon: CalendarCheck, title: "Monatsabos", text: "Feste Trainingstermine", id: "abos" },
];

export default function PackagePromo() {
  return (
    <section className="mt-14 relative overflow-hidden rounded-2xl border border-[#c1ff72]/60 bg-[#0d0f0b] p-6 sm:p-10 shadow-[0_0_40px_-12px_rgba(193,255,114,0.35)]" data-testid="package-promo">
      <div className="pointer-events-none absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#c1ff72]/10 blur-3xl" />
      <p className="relative text-xs sm:text-sm font-semibold tracking-[0.25em] text-[#c1ff72]" data-testid="package-promo-kicker">MEHR TRAINIEREN. WENIGER ZAHLEN.</p>
      <h2 className="relative mt-3 font-['Bebas_Neue'] text-4xl sm:text-5xl lg:text-6xl leading-none text-white tracking-wide" data-testid="package-promo-title">DEIN TRAINING. DEIN VORTEIL.</h2>
      <p className="relative mt-4 max-w-2xl text-sm sm:text-base text-[#A1A1AA]" data-testid="package-promo-text">
        Sichere dir deine 5er- oder 10er-Karte oder trainiere regelmäßig mit einem Monatsabo – zum attraktiven Paketpreis.
      </p>
      <div className="relative mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {OFFERS.map(({ Icon, title, text, id }) => (
          <div key={id} className="flex items-center gap-4 rounded-xl border border-white/10 bg-white/[0.03] p-5" data-testid={`package-promo-${id}`}>
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-[#c1ff72]/40 bg-[#c1ff72]/10"><Icon className="h-6 w-6 text-[#c1ff72]" /></span>
            <div><p className="font-semibold text-white">{title}</p><p className="text-sm text-[#A1A1AA]">{text}</p></div>
          </div>
        ))}
      </div>
      <Link to="/pakete" className="group relative mt-8 flex min-h-[56px] w-full items-center justify-center gap-2 rounded-xl bg-[#c1ff72] px-4 py-4 text-center text-sm sm:text-base font-bold tracking-wide text-[#0A0A0A] transition-[background-color,box-shadow,transform] duration-200 hover:bg-[#d4ff99] hover:shadow-[0_0_24px_rgba(193,255,114,0.45)] active:scale-[0.99]" data-testid="package-promo-cta">
        TRAININGSKARTEN & MONATSABOS ENTDECKEN<ArrowRight className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" />
      </Link>
    </section>
  );
}
